// Custom icon static resources

import {
  AuditOutline,
  BulbOutline,
  DashboardOutline,
  DesktopOutline,
  ExceptionOutline,
  FlagOutline,
  FundOutline,
  InfoOutline,
  LinkOutline,
  ProfileOutline,
  SafetyOutline,
  SecurityScanOutline,
  StopOutline,
  ShopOutline,
  PartitionOutline,
  SkinOutline,
  BarcodeOutline,
  AppstoreAddOutline,
  InsertRowBelowOutline,
  InteractionOutline,
  EnvironmentOutline,
  CarOutline,
  ExportOutline,
  UngroupOutline,
  SolutionOutline,
  ProjectOutline,
  QrcodeOutline,
  ClusterOutline,
  AreaChartOutline,
  BarChartOutline,
  UserSwitchOutline,
  BankOutline,
  ReadOutline,
  ShareAltOutline,
} from '@ant-design/icons-angular/icons';

export const ICONS = [
  BulbOutline,
  DashboardOutline,
  DesktopOutline,
  ExceptionOutline,
  InfoOutline,
  LinkOutline,
  ProfileOutline,
  SafetyOutline,
  SecurityScanOutline,
  AuditOutline,
  FlagOutline,
  StopOutline,
  FundOutline,
  ShopOutline,
  PartitionOutline,
  SkinOutline,
  BarcodeOutline,
  AppstoreAddOutline,
  InsertRowBelowOutline,
  InteractionOutline,
  EnvironmentOutline,
  CarOutline,
  ExportOutline,
  UngroupOutline,
  SolutionOutline,
  ProjectOutline,
  QrcodeOutline,
  ClusterOutline,
  AreaChartOutline,
  BarChartOutline,
  UserSwitchOutline,
  BankOutline,
  ReadOutline,
  ShareAltOutline,
];
